import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { CompletedView } from "./view";
import { useDispatch, useSelector } from "react-redux";
import { quoteAll, quoteAllClearData, } from "../../../store/generateQuote/actions";
import LocalStorageService from "../../../services/localStorage";
import { useNavigate, useParams } from "react-router-dom";
import { formattedDate, formattedDateWithTime } from "../../../utils/date";
import { downloadReports } from "../../../fnx/reportsDowload";
import showToast from "../../../services/toast";
import { Branches } from "../../../store/branches/actions";
import { useProjectsByCustomerId } from "../../../fnx/projectsByCustomerId";
import { showErrorToast } from "../../../fnx/showError";
import { useTranslation } from "react-i18next";
import { getCatalogStatusQuote, getCatalogStatusQuoteClearData, } from "../../../store/catalog/actions";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var Completed = function () {
    var id = useParams().id;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = React.useState(true), enable = _a[0], setEnable = _a[1];
    var _b = React.useState(1), page = _b[0], setPage = _b[1];
    var _c = React.useState(5000), limit = _c[0], setLimit = _c[1];
    var _d = useState([]), rows = _d[0], setRows = _d[1];
    var _e = React.useState(""), startDate = _e[0], setStartDate = _e[1];
    var _f = React.useState(""), endDate = _f[0], setEndDate = _f[1];
    var _g = React.useState(false), isLoadin = _g[0], setIsLoading = _g[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _h = useState(""), nameSearch = _h[0], setNameSearch = _h[1];
    var _j = useState(""), description = _j[0], setDescription = _j[1];
    var _k = useState([]), branchesOptions = _k[0], setBranchesOptions = _k[1];
    var _l = useState([]), insuranceOptions = _l[0], setInsuranceOptions = _l[1];
    var _m = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _m[0], setSeeToast = _m[1];
    var fields = "policyId.code,code,productId.description,policyId.effectiveFrom,creationDate,firstNameA,firstNameB,lastNameA,lastNameB,numberId,customerAccount.accountType.description,customerAccount.accountNumber,customerAccount.amount,catalogStatusQuote.description,user.fullName,user.email,clientId.description,catalogCancellation.createdAt,catalogCancellation.description";
    var labelFields = "Póliza,Cotización,Producto,Fecha efectiva,Póliza creada el,Primer nombre,Segundo nombre,Primer apellido,Segundo apellido,No. Documento,Tipo de cuenta,No. de cuenta,Prima,Estado,Nombre del empleado,Usuario,Aseguradora,Fecha de cancelación,Motivo de cancelación";
    var idSalesCompleted = "99d9c7f3-e138-4a36-920b-1de59346ea10";
    var idSalesCanceled = "d40de8d2-f71a-42e7-98b2-b30efa6b153a";
    var _o = React.useState(""), sponsorId = _o[0], setSponsorId = _o[1];
    var _p = useState(false), trigger = _p[0], setTrigger = _p[1];
    var responseInsurance = useProjectsByCustomerId(clientId, trigger, "", "", sponsorId).responseInsurance;
    var _q = useSelector(function (state) { return ({
        responseAllQuote: state.Quote.responseAllQuote,
        errorAllQuote: state.Quote.errorAllQuote,
        loadingAllQuote: state.Quote.loadingAllQuote,
    }); }), responseAllQuote = _q.responseAllQuote, errorAllQuote = _q.errorAllQuote, loadingAllQuote = _q.loadingAllQuote;
    var _r = useSelector(function (state) {
        var _a;
        return ({
            responseBranches: (_a = state.Branches.responseBranches) === null || _a === void 0 ? void 0 : _a.data,
            errorBranches: state.Branches.errorBranches,
            loadingBranches: state.Branches.loadingBranches,
        });
    }), responseBranches = _r.responseBranches, errorBranches = _r.errorBranches, loadingBranches = _r.loadingBranches;
    var _s = useSelector(function (state) {
        var _a;
        return ({
            responseGetCatalogStatusQuote: (_a = state.Catalog.responseGetCatalogStatusQuote) === null || _a === void 0 ? void 0 : _a.data,
            errorGetCatalogStatusQuote: state.Catalog.errorGetCatalogStatusQuote,
            loadingGetCatalogStatusQuote: state.Catalog.loadingGetCatalogStatusQuote,
        });
    }), responseGetCatalogStatusQuote = _s.responseGetCatalogStatusQuote, errorGetCatalogStatusQuote = _s.errorGetCatalogStatusQuote, loadingGetCatalogStatusQuote = _s.loadingGetCatalogStatusQuote;
    useEffect(function () {
        var description1 = t("salesReport.description1");
        var description2 = t("salesReport.description2");
        var description3 = t("salesReport.description3");
        var foundItem = responseGetCatalogStatusQuote === null || responseGetCatalogStatusQuote === void 0 ? void 0 : responseGetCatalogStatusQuote.find(function (item) { return item.id === id; });
        if (foundItem && foundItem.description === "Emitida") {
            setDescription(description1);
        }
        else if (foundItem && foundItem.description === "Cancelada") {
            setDescription(description2);
        }
        else {
            setDescription(description3);
        }
    }, [responseGetCatalogStatusQuote, id]);
    useEffect(function () {
        setDescription("");
        if (!responseBranches) {
            dispatch(Branches({
                enable: enable,
                page: page,
                limit: limit,
                clientId: clientId,
            }));
        }
        if (!responseAllQuote) {
            getQuoteAll();
        }
        if (!responseGetCatalogStatusQuote) {
            dispatch(getCatalogStatusQuote({ enable: enable, page: page, limit: limit }));
        }
        if (!responseAllQuote) {
            getQuoteAll();
        }
        if (!responseGetCatalogStatusQuote) {
            dispatch(getCatalogStatusQuote({ enable: enable, page: page, limit: limit }));
        }
    }, []);
    useEffect(function () {
        if (errorAllQuote) {
            showErrorToast(errorAllQuote, setSeeToast, t);
        }
    }, [errorAllQuote]);
    useEffect(function () {
        if (errorGetCatalogStatusQuote) {
            showErrorToast(errorGetCatalogStatusQuote, setSeeToast, t);
        }
    }, [errorGetCatalogStatusQuote]);
    useEffect(function () {
        if (errorBranches) {
            showErrorToast(errorBranches, setSeeToast, t);
        }
    }, [errorBranches]);
    useEffect(function () {
        if (Array.isArray(responseAllQuote)) {
            setDataReportStorybook(responseAllQuote);
        }
    }, [responseAllQuote]);
    useEffect(function () {
        if (Array.isArray(responseInsurance)) {
            setInsuranceOptionsStorybook(responseInsurance);
        }
    }, [responseInsurance]);
    useEffect(function () {
        if (nameSearch) {
            getQuoteAll();
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    useEffect(function () {
        if (Array.isArray(responseBranches)) {
            setBranchesOptionsStorybook(responseBranches);
        }
    }, [responseBranches]);
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var onCloseSearch = function () {
        setNameSearch("");
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            catalogStatusQuote: id,
            page: page,
            limit: limit,
            search: "",
        }));
    };
    var getQuoteAll = function () {
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            catalogStatusQuote: id,
            page: page,
            limit: limit,
            search: nameSearch,
        }));
    };
    var setBranchesOptionsStorybook = function (responseBranches) {
        var dataBranches = [];
        responseBranches === null || responseBranches === void 0 ? void 0 : responseBranches.map(function (item) {
            if (item.id && item.name) {
                dataBranches.push({
                    id: item.id,
                    name: item.name,
                    active: false,
                });
            }
        });
        setBranchesOptions(dataBranches);
    };
    var setInsuranceOptionsStorybook = function (responseProject) {
        var dataInsurance = [];
        responseProject === null || responseProject === void 0 ? void 0 : responseProject.map(function (item) {
            if (item.id && item.description) {
                dataInsurance.push({
                    id: item.id,
                    name: item.description,
                    active: false,
                });
            }
        });
        setInsuranceOptions(dataInsurance);
    };
    var setDataReportStorybook = function (responseAllQuote) {
        var dataR = responseAllQuote === null || responseAllQuote === void 0 ? void 0 : responseAllQuote.map(function (item) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
            return ({
                id: item === null || item === void 0 ? void 0 : item.id,
                certificate: (item === null || item === void 0 ? void 0 : item.policyId) ? (_a = item === null || item === void 0 ? void 0 : item.policyId) === null || _a === void 0 ? void 0 : _a.code : item.code,
                product: (_b = item === null || item === void 0 ? void 0 : item.productId) === null || _b === void 0 ? void 0 : _b.description,
                creationDate: (item === null || item === void 0 ? void 0 : item.policyId)
                    ? formattedDate((_c = item === null || item === void 0 ? void 0 : item.policyId) === null || _c === void 0 ? void 0 : _c.effectiveFrom)
                    : formattedDate(item === null || item === void 0 ? void 0 : item.creationDate),
                names: "".concat(item === null || item === void 0 ? void 0 : item.firstNameA, " ").concat(item === null || item === void 0 ? void 0 : item.firstNameB),
                lastNames: "".concat(item === null || item === void 0 ? void 0 : item.lastNameA, " ").concat(item === null || item === void 0 ? void 0 : item.lastNameB),
                identificationNumber: item === null || item === void 0 ? void 0 : item.numberId,
                paymentType: (_d = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _d === void 0 ? void 0 : _d.accountType.description,
                accountNumber: (_e = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _e === void 0 ? void 0 : _e.accountNumber,
                prime: "RD$ ".concat((_f = item === null || item === void 0 ? void 0 : item.customerAccount) === null || _f === void 0 ? void 0 : _f.amount),
                status: (_g = item === null || item === void 0 ? void 0 : item.catalogStatusQuote) === null || _g === void 0 ? void 0 : _g.description,
                userName: (_h = item === null || item === void 0 ? void 0 : item.user) === null || _h === void 0 ? void 0 : _h.fullName,
                user: (_j = item === null || item === void 0 ? void 0 : item.user) === null || _j === void 0 ? void 0 : _j.email,
                branch: (_k = item === null || item === void 0 ? void 0 : item.branchData) === null || _k === void 0 ? void 0 : _k.name,
                cancellationDate: ((_l = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _l === void 0 ? void 0 : _l.createdAt) &&
                    formattedDate((_m = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _m === void 0 ? void 0 : _m.createdAt),
                reasonCancellation: (_o = item === null || item === void 0 ? void 0 : item.catalogCancellation) === null || _o === void 0 ? void 0 : _o.description,
                insuranceCarrier: (_p = item === null || item === void 0 ? void 0 : item.sponsor) === null || _p === void 0 ? void 0 : _p.name,
            });
        });
        setRows(dataR);
        dispatch(quoteAllClearData());
    };
    var onClickDownload = function (item) {
        setIsLoading(true);
        downloadReports(item, clientId, enable, page, limit, id ? id : "", startDate, endDate, fields, labelFields)
            .then(function () {
            setSeeToast({
                show: true,
                message: t("salesReport.downloadFile"),
                type: typeAlert.success,
            });
        })
            .catch(function (error) {
            console.error("Error al descargar el archivo:", error);
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var filterStatus = function (item) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var idBranch = item === null || item === void 0 ? void 0 : item.branch.map(function (item) { return item.id; }).join(",");
        var idInsurance = item === null || item === void 0 ? void 0 : item.insurance.map(function (item) { return item.id; }).join(",");
        setStartDate(formattedDateWithTime((_a = item === null || item === void 0 ? void 0 : item.dateRange) === null || _a === void 0 ? void 0 : _a.startDate) === "undefined" ||
            formattedDateWithTime((_b = item === null || item === void 0 ? void 0 : item.dateRange) === null || _b === void 0 ? void 0 : _b.startDate) === "null" ||
            formattedDateWithTime((_c = item === null || item === void 0 ? void 0 : item.dateRange) === null || _c === void 0 ? void 0 : _c.startDate) === "NA"
            ? ""
            : formattedDateWithTime((_d = item === null || item === void 0 ? void 0 : item.dateRange) === null || _d === void 0 ? void 0 : _d.startDate));
        setEndDate(formattedDateWithTime((_e = item === null || item === void 0 ? void 0 : item.dateRange) === null || _e === void 0 ? void 0 : _e.endDate) === "undefined" ||
            formattedDateWithTime((_f = item === null || item === void 0 ? void 0 : item.dateRange) === null || _f === void 0 ? void 0 : _f.endDate) === "null" ||
            formattedDateWithTime((_g = item === null || item === void 0 ? void 0 : item.dateRange) === null || _g === void 0 ? void 0 : _g.endDate) === "NA"
            ? ""
            : formattedDateWithTime((_h = item === null || item === void 0 ? void 0 : item.dateRange) === null || _h === void 0 ? void 0 : _h.endDate));
        dispatch(quoteAll({
            clientId: clientId,
            enable: enable,
            catalogStatusQuote: id,
            creationDateStart: formattedDateWithTime((_j = item === null || item === void 0 ? void 0 : item.dateRange) === null || _j === void 0 ? void 0 : _j.startDate) === "undefined" ||
                formattedDateWithTime((_k = item === null || item === void 0 ? void 0 : item.dateRange) === null || _k === void 0 ? void 0 : _k.startDate) === "null" ||
                formattedDateWithTime((_l = item === null || item === void 0 ? void 0 : item.dateRange) === null || _l === void 0 ? void 0 : _l.startDate) === "NA"
                ? ""
                : formattedDateWithTime((_m = item === null || item === void 0 ? void 0 : item.dateRange) === null || _m === void 0 ? void 0 : _m.startDate),
            creationDateEnd: formattedDateWithTime((_o = item === null || item === void 0 ? void 0 : item.dateRange) === null || _o === void 0 ? void 0 : _o.endDate) === "undefined" ||
                formattedDateWithTime((_p = item === null || item === void 0 ? void 0 : item.dateRange) === null || _p === void 0 ? void 0 : _p.endDate) === "null" ||
                formattedDateWithTime((_q = item === null || item === void 0 ? void 0 : item.dateRange) === null || _q === void 0 ? void 0 : _q.endDate) === "NA"
                ? ""
                : formattedDateWithTime((_r = item === null || item === void 0 ? void 0 : item.dateRange) === null || _r === void 0 ? void 0 : _r.endDate),
            branches: idBranch,
            projectIds: idInsurance,
            page: page,
            limit: limit,
        }));
    };
    var onClickBack = function () {
        dispatch(getCatalogStatusQuoteClearData());
        navigate("/report");
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingAllQuote ||
                    isLoadin ||
                    loadingGetCatalogStatusQuote ||
                    loadingBranches, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: isLoadin ? "Descargando archivo" : "Cargando Pólizas." }), _jsx(CompletedView, { idSalesCompleted: idSalesCompleted, idSalesCanceled: idSalesCanceled, searchFilter: searchFilter, onCloseSearch: onCloseSearch, branchOptions: branchesOptions, rows: rows, filterStatus: filterStatus, id: id, downloadFile: onClickDownload, insuranceOptions: insuranceOptions, onClickBack: onClickBack, description: description })] }));
};
